import React, { Component } from 'react';
import './style.css';

class DeckManager extends Component {
  render() {
    return (
      <div>
        Deck Manager
      </div>
    );
  }
}

export default DeckManager;


/** WEBPACK FOOTER **
 ** ./src/components/DeckManager/index.js
 **/